export const HISTORY_CONTEXT = 'history-context';
export const HOME_CONTEXT = 'home-context';
export const LOOMS_CONTEXT = 'looms-context';
export const PROFILE_CONTEXT = 'profile-context';
export const SHARE_CONTEXT = 'share-context';
export const TAG_CONTEXT = 'tag-context';

export const CARD_CAPABILITIES: Record<string, string[]> = {
  canDrag: [LOOMS_CONTEXT],
  hasBulkActions: [LOOMS_CONTEXT, TAG_CONTEXT],
  hasDropdownActions: [
    HISTORY_CONTEXT,
    LOOMS_CONTEXT,
    PROFILE_CONTEXT,
    TAG_CONTEXT,
  ],
  hasPinIcon: [PROFILE_CONTEXT],
  promptOnUnpublish: [PROFILE_CONTEXT],
};
